import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from '../components/confirm-modal/confirm-modal.component';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';

@Injectable()
export class ModalService {
    modalRef: BsModalRef;
 
    constructor(private bsModalService: BsModalService,
        public dialogService: DialogService) { }
    
    public confirm(title: string, message: string, size: any = 'lg', showCancel = true, closeAfterSuccess = false): any {
        const config: ModalOptions = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: true,
            animated: true
        };
        const modal = this.bsModalService.show(ConfirmModalComponent, config);
      (<ConfirmModalComponent>modal.content).showConfirmationModal(
          title,
          message,
          '',
          showCancel,
          closeAfterSuccess
      );
        return (<ConfirmModalComponent>modal.content).onClose;
    }
    
    public alert(title: string, message: string, size: any = 'lg', showCancel = true, ignoreBackdropClick = false): any {
        let type = 'alert';
        const config: ModalOptions = {
            ignoreBackdropClick: ignoreBackdropClick,
        };
        const modal = this.bsModalService.show(ConfirmModalComponent, config);
      (<ConfirmModalComponent>modal.content).showConfirmationModal(
          title,
          message,
          type,
          showCancel
      );
        return (<ConfirmModalComponent>modal.content).onClose;
    }
    public confirmCustomBtn(title: string, message: string, size: any = 'lg',config:any =false, showCancel = true, enableCstmBtn:any=false, config1?: ModalOptions): any {
        if(config1 == undefined)
        config1 = {
            backdrop: true,
            keyboard: true,
            ignoreBackdropClick: true,
            animated: true
        };
        const modal = this.bsModalService.show(ConfirmModalComponent, config1);
      (<ConfirmModalComponent>modal.content).showConfirmationModalCustom(
          title,
          message,
          config, 
          showCancel,
          enableCstmBtn
      );
        return (<ConfirmModalComponent>modal.content).onClose;
    }
}
